<template lang="pug">
f7-page#application-done
  navbar(title="申込完了")

  background-image
    .application-done-body
      .done-message
        p 無料体験レッスンにお申込みいただき
        p ありがとうございます🌈
        br/
        p まずは、{{ name }}様にサービスを理解いただき、
        p よりよい先生を紹介するための15分程度の電話カウンセリングにご参加ください✨
        br/
        p ご登録いただきましたアドレス宛に
        p 日程調整のメールをお送りしております。
        p ご返信お願い致します！
      .application-done-footer
        large-button(
          title="OK"
          @click="onClickOk")
</template>

<style lang="scss" scoped>
p {
  margin: 0;
}
.application-done-body {
  padding: 32px 16px;
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  margin: 56px 8px;

  .title {
    @extend %headline-detail-text;
    margin-top: 48px;
  }

  .mail-address {
    @extend %headline-lists-text;
    height: 64px;
    line-height: 64px;
    border-radius: 12px;
    background-color: rgba(255, 255, 255, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    text-align: center;
    margin: 32px 0 24px;
  }

  .done-message {
    @extend %body-text;
  }

  .application-done-footer {
    position: absolute;
    left: 0;
    bottom: 32px;
    width: 100%;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import LargeButton from '@/components/atoms/LargeButton'

export default {
  components: { LargeButton },
  computed: mapGetters('application', ['name']),
  methods: {
    onClickOk() {
      this.$f7router.navigate(
        { name: 'PublicRoot' },
        { clearPreviousHistory: true }
      )
    },
  },
}
</script>
